<template>
  <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("finance.mandateNameLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.taxNumberLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.mandateStatusLabel") }}</strong>
          </td>
          <td valign="middle">
            <strong>{{ $t("finance.mandateCreatedLabel") }}</strong>
          </td>
          <td cvalign="middle">
            <strong>{{ $t("finance.seeDetailsLabel") }}</strong>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.mandates === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(mandate, index) in mandates">
          <tr
            :key="index"
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            <td valign="middle">
              {{ mandate.name }}
            </td>
            <td valign="priority-1">
              {{ mandate.tax_number }}
            </td>
            <td valign="priority-1">
              {{ $t('finance.mandateStatus_' + mandate.status) }}
            </td>
            <td valign="middle" class="priority-1">
              {{ displayDateTimestamp(mandate.created) }}
            </td>
            <td valign="middle">
                  <a
                    class="see-more cursor-pointer"
                    @click="getMandateDetails(mandate)"
                  >
                    <font-awesome-icon
                      icon="arrow-alt-circle-right"
                      size="2x"
                    />
                  </a>
                  </td>
          </tr>
          
        </template>
      </tbody>
    </table>
    <div id="modal_popup_details" class="modal-popup">
      <div class="modal-popup-content">
        <a
          onclick="document.getElementById('modal_popup_details').style.visibility = 'hidden'"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.mandateDetails" class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-between">
            <p >
              <strong>{{ $t("finance.mandateReferenceLabel") }} : &nbsp;&nbsp;</strong>
              <span>            
              <span>{{ this.mandateDetails.reference }} </span>
              </span>
            </p>
            <p >
              <strong>{{ $t("finance.mandateUmrLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.mandateDetails.umr }} </span>
            </p>
            <p >
              <strong>{{ $t("finance.mandateLimitAmountLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.mandateDetails.limit_amount }}</span>
            </p>
            <p >
              <strong>{{ $t("finance.mandateStatusLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ $t('finance.mandateStatus_' + this.mandateDetails.status) }}</span>
            </p>
          </div>
          <br />
          <div class="d-flex flex-row justify-content-between">
            <p >
              <strong>{{ $t("finance.validFromLabel") }} : &nbsp;&nbsp;</strong>
              <span>            
              <span>{{ this.mandateDetails.valid_from }} </span>
              </span>
            </p>
            <p >
              <strong>{{ $t("finance.validToLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ this.mandateDetails.valid_to }} </span>
            </p>
            <p >
              <strong>{{ $t("finance.mandateCreatedLabel") }} : &nbsp;&nbsp;</strong>
              <span>{{ displayDateTimestamp(this.mandateDetails.created) }}</span>
            </p>
          </div>
          <br />
          <div>
            <table width="100%">
              <thead>
                <tr>
                  <td valign="middle">
                    <strong>{{ $t("finance.customerTypeLabel") }}</strong>
                  </td>
                  <td valign="middle">
                    <strong>{{ $t("finance.productLabel") }}</strong>
                  </td>
                  <td valign="middle">
                    <strong>{{ $t("finance.customerIdentifierLabel") }}</strong>
                  </td>
                  <td valign="middle">
                    <strong>{{ $t("finance.mandateNameLabel") }}</strong>
                  </td>
                  <td valign="middle">
                    <strong>{{ $t("finance.mandateIbanLabel") }}</strong>
                  </td>                  
                  <td valign="middle">
                    <strong>{{ $t("finance.mandateStatusLabel") }}</strong>
                  </td>
                  <td valign="middle">
                    <strong>{{ $t("finance.mandateCreatedLabel") }}</strong>
                  </td>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(customer, index) in this.mandateDetails.customers">
                    <tr
                      :key="index"
                      class="trhover parent"
                      :class="index % 2 === 0 && 'gri-cell'"
                    >
                      <td valign="middle">
                      {{ $t('finance.companyType_' + customer.type) }}
                      </td>
                      <td valign="middle">
                        {{ $t('finance.product_' + customer.product) }}
                      </td>
                      <td valign="middle">
                        {{ customer.identifier }}
                      </td>
                      <td valign="middle">
                        {{ customer.name }}
                      </td>
                      <td valign="middle">
                        {{ customer.iban }}
                      </td>
                      <td valign="middle">
                        {{ $t('finance.customerStatus_' + customer.status) }}
                      </td>
                      <td valign="middle">
                        {{ displayDateTimestamp(customer.created) }}
                      </td>                                                                  
                      </tr>
                      </template>
                      </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import moment from "moment";
  import httpServiceFinance from "@/http/http-finance.js";
  import Cookies from "js-cookie";

  export default {
    name: "MandatesTable",
    props: {
      mandates: Array,
      msg: String,
    },
    data() {
      return {
        mandateDetails: {},

      };
    },
    methods: {
      getMandateDetails(selectedMandate) {
        // this.mandateDetails = {
        //         "id": 100,
        //         "reference": "REF123",
        //         "umr": "UMR123456",
        //         "limitAmount": 1000.00,
        //         "validFrom": "03-03-2011",
        //         "validTo": "03-07-2026",
        //         "status": "A",
        //         "created": 1780775433166,
        //         "customers": [
        //           {
        //             "id": 1,
        //             "type": "CL",
        //             "product": 11,
        //             "identifier": 1,
        //             "name": "UP ROMANIA SRL",
        //             "iban": "RO49AAAA1B31007593840000",
        //             "status": "A",
        //             "created": 1780775433166
        //           }
        //         ]
        //       }
        //   this.showModalPopup("modal_popup_details", true);

        //       return;
        this.showModalPopup("modal_popup_loading", true);
        httpServiceFinance.financeService
          .getClientMandateDetails(
            selectedMandate.id,
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false);
          })
          .then((response) => {
            if (response.status == 200) {
              this.mandateDetails = response.data;
              this.showModalPopup("modal_popup_loading", false);
              this.showModalPopup("modal_popup_details", true);
            } else if (response.status == 400 || response.status == 403) {
              this.mandateDetails = null;
            }
          });
      },
      displayDateTimestamp(timestamp) {
        return moment(timestamp).format(
          "DD/MM/YYYY"
        );
      },
    },
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>

<style scoped>
  #modal_popup_details .modal-popup-content {
    text-align: left !important;
    max-width: 60% !important;
    width: 60%;
  }

  .invoices-table {
    padding: 1px;
  }

  .overflow {
    overflow-wrap: break-word;
  }

  .max-width-230 {
    max-width: 230px;
  }

  p {
    margin: 5px !important;
  }

  .border-top {
    border-top: 1px solid grey;
    margin-top: 15px;
  }

  .hover-table tr.trhover:hover a,
  .hover-table tr.trhover:hover a:hover {
    color: #fff;
  }

</style>
<style scoped src="@/assets/styles/beneficiary.css"></style>
